import React, { useState, useRef, useEffect, useCallback } from "react";

import "./ToolTip.css";

const ToolTip = ({
  children,
  className,
  text = "Add tooltip text",
  direction = "top",
  show = "hover"
}) => {
  const containerRef = useRef(null);
  const tooltipRef = useRef(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [isHovered, setIsHovered] = useState(false);
  const [isPinned, setIsPinned] = useState(false);

  const calculatePosition = useCallback(() => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      let top, left;

      left = rect.left + rect.width / 2;

      if (direction === "top") {
        top = rect.top - 8;
      } else if (direction === "bottom") {
        top = rect.bottom + 8;
      } else if (direction === "left") {
        top = rect.top + rect.height / 2;
        left = rect.left - 8;
      } else if (direction === "right") {
        top = rect.top + rect.height / 2;
        left = rect.right + 8;
      }

      setPosition({ top, left });
    }
  }, [direction]);

  const handleMouseEnter = () => {
    calculatePosition();
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleClick = (e) => {
    e.stopPropagation();
    calculatePosition();
    setIsPinned(!isPinned);
  };

  // Handle click outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        isPinned &&
        containerRef.current &&
        !containerRef.current.contains(e.target) &&
        tooltipRef.current &&
        !tooltipRef.current.contains(e.target)
      ) {
        setIsPinned(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isPinned]);

  // Handle scroll when pinned
  useEffect(() => {
    if (!isPinned) return;

    const handleScroll = () => {
      calculatePosition();
    };

    window.addEventListener("scroll", handleScroll, true);
    return () => {
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [isPinned, calculatePosition]);

  const isVisible = (isHovered || isPinned) && show === "hover";

  return (
    <div 
      ref={containerRef}
      className={`tooltip-container ${className || ""}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      {children}
      {isVisible && (
        <div
          ref={tooltipRef}
          className={`tooltip-fixed tooltip-fixed-${direction} ${isPinned ? "tooltip-pinned" : ""}`}
          style={{ top: position.top, left: position.left }}
          onClick={(e) => e.stopPropagation()}
        >
          <p className="tooltip-text">{text}</p>
        </div>
      )}
    </div>
  );
};

export default ToolTip;
